import {jsx} from 'panel';

import * as colors from 'common/util/colors';
import {ButtonEl} from 'common/components/button';
import {ButtonSize, ButtonTheme} from 'common/components/button/constants';

import {ChildMenu} from '../child-menu';

export function BetaMenuActionBar({
  isBetaMenu,
  setBetaVersion,
}: {
  isBetaMenu: boolean;
  setBetaVersion: ChildMenu<any, any>['setBetaVersion'];
}) {
  return (
    <div
      sel='.menu-action-bar'
      style={{
        'align-items': `center`,
        'background-color': colors.gray1,
        'box-sizing': `border-box`,
        'font-size': `12px`,
        color: colors.gray4,
        display: `flex`,
        padding: `10px 6px`,
        width: `0`,
        'flex-grow': `1`,
        'border-radius': isBetaMenu ? null : `0px 0px 12px 12px`,
      }}
    >
      <span style={{'flex-grow': `1`, 'padding-left': `6px`}}>We're changing our menu</span>
      <ButtonEl
        attrs={{theme: ButtonTheme.Tertiary, size: ButtonSize.Small}}
        style={{color: colors.gray3, 'font-weight': `400`}}
        on={{click: () => setBetaVersion({isOn: !isBetaMenu})}}
      >
        {isBetaMenu ? `Use Classic` : `Try New`}
      </ButtonEl>
    </div>
  );
}
